import {Organization} from '@catalyst-zero/company-schema/types/Organization'
import {Suspense, useMemo, useState} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'

import Boundary from 'catalystZeroComponents/boundary'
import FullPageLoader from 'catalystZeroComponents/fullPageLoader'

import style from './App.module.css'
import {FactorLibrary} from './components/factor-library/factor-library'
import Footer from './components/footer'
import Header from './components/header'
import LoginCallback from './components/login-callback/LoginCallback'
import LoginProvider from './components/login-provider'
import OrganizationContext from './context/OrganizationContext'
import Organizations from './routes/organizations'
import OrganizationOrganizationId from './routes/organizations/organizationId'
import {CALLBACK_PATH} from './utils/constants'

function App() {
  const [organization, setOrganization] = useState<Organization | undefined>(undefined)
  const organizationContext = useMemo(() => ({organization, setOrganization}), [organization, setOrganization])

  return (
    <LoginProvider>
      <OrganizationContext.Provider value={organizationContext}>
        <Suspense fallback={<FullPageLoader />}>
          <Header />
          <Boundary>
            <div className={style.content}>
              <Routes>
                <Route element={<Organizations />} path="organizations" />
                <Route element={<FactorLibrary />} path="factor-library/*" />
                <Route element={<OrganizationOrganizationId />} path="organizations/:organizationId/*" />
                <Route element={<LoginCallback />} path={CALLBACK_PATH} />
                <Route element={<Navigate replace to="/organizations" />} path="*" />
              </Routes>
            </div>
          </Boundary>
          <Footer />
        </Suspense>
      </OrganizationContext.Provider>
    </LoginProvider>
  )
}

export default App
